export enum AnalyticEventType {
  SYSTEM_ACTION = 'system-action',
  USER_ACTION = 'user-action'
}
